import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { FaqAccordion } from '../components/faq/FaqAccordion';
import { CtaBanner } from '../components/ui/CtaBanner';
import { FAQS, DISCLAIMER } from '../data/content';
import { IMAGES } from '../data/images';
import { useLanguage } from '../i18n/LanguageContext';
export function Faq() {
  const {
    lang,
    p
  } = useLanguage();
  const f = p.faq;
  return <>
      <Seo title={f.seo.title} description={f.seo.description} data-id="element-439" data-mp="3gsuxbir1m2te" />
      <PageHero eyebrow={f.hero.eyebrow} title={f.hero.title} description={f.hero.description} breadcrumb={f.hero.breadcrumb} image={IMAGES.hero} data-id="element-440" data-mp="3guegpi7zwtze" />

      <section className="w-full bg-white py-24 lg:py-32" data-id="element-441" data-mp="3pqx64kh0pzr8">
        <div className="mx-auto grid max-w-container gap-14 px-6 lg:grid-cols-12 lg:gap-20" data-id="element-442" data-mp="3lsfvhqye2752">
          <div className="lg:col-span-8" data-id="element-443" data-mp="265i5y0a80ut3">
            <Reveal data-id="element-444" data-mp="266jjcbepltdz">
              <FaqAccordion items={FAQS.map(item => item[lang])} data-id="element-445" data-mp="2a61ysrnrhc9f" />
            </Reveal>
          </div>

          <aside className="lg:col-span-4" data-id="element-446" data-mp="2f5em1dijolcj">
            <Reveal delay={0.1} data-id="element-447" data-mp="2f3k13z79wt8g">
              <div className="rounded-3xl bg-navy p-8 shadow-soft" data-id="element-448" data-mp="2f7hlsp9i1sug">
                <h2 className="eyebrow text-gold" data-id="element-449" data-mp="2k5svmzzso3co">{f.asideTitle}</h2>
                <p className="mt-4 font-display text-2xl leading-snug text-white" data-id="element-450" data-mp="2p445haq3aduw">{f.asideLead}</p>
                <p className="mt-4 text-sm leading-relaxed text-navy-100/70" data-id="element-451" data-mp="2t44jiu9a0n1f">{f.asideText}</p>
                <Link to="/contact" className="group mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-[12px] font-semibold uppercase tracking-[0.16em] text-navy transition-colors hover:bg-gold-light" data-id="element-452" data-mp="2xvcuhuq98ggp">
                  {f.asideCta}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-453" data-mp="3ctyj3ui8g6g7" />
                </Link>
              </div>
            </Reveal>
            <Reveal delay={0.2} data-id="element-454" data-mp="2i3tztm0fzr4y">
              <div className="mt-6 rounded-3xl border border-navy-100 bg-mist p-8" data-id="element-455" data-mp="2wut44ku8vtiq">
                <h2 className="eyebrow text-gold-dark" data-id="element-456" data-mp="2s44cn5ikewjl">{f.noticeTitle}</h2>
                <p className="mt-4 text-xs leading-relaxed text-charcoal-light" data-id="element-457" data-mp="2s2005z6lop7p">
                  {DISCLAIMER[lang]}
                </p>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>

      <CtaBanner data-id="element-458" data-mp="3ft5do7p2j5eu" />
    </>;
}